import { render, staticRenderFns } from "./ArtigoCriar.vue?vue&type=template&id=548f583b"
import script from "./ArtigoCriar.vue?vue&type=script&lang=js"
export * from "./ArtigoCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports